import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const GeneralService = {

  getAllRole: async () => {
    try {
      const response = await axios.get(ENDPOINT.roles);
      return response.data;
    } catch (error) {
      console.error("Error fetching enquiries:", error.message);
      throw error;
    }
  }

}